<template>

  <v-app dark>

    <s-loading :when="loading.active" :message="loading.message"></s-loading>

    <MainAppBar app />

    <v-content class="pt-0 ">
      <v-container fluid pa-0 ma-0>

        <router-view></router-view>

      </v-container>
    </v-content>

    <MainFooter app />

  </v-app>

</template>

<script>

import MainAppBar from '@/components/MainAppBar.vue';
import MainFooter from '@/components/MainFooter.vue';

export default {
  name: 'app',
  components: {
    MainAppBar,
    MainFooter,
  },
  data: () => ({
  }),
  created()
  {
	if(localStorage.getItem('accessToken') && localStorage.getItem('accessToken') != undefined && localStorage.getItem('accessToken') != 'undefined')
	{
		let accessToken = localStorage.getItem('accessToken')
		this.$store.commit('UserLogin', accessToken);
	}
	else if(this.$router.currentRoute.name == 'authentication' || this.$router.currentRoute.name == 'wachtwoord')
	{
		this.$store.commit('UserLogout');
		this.$router.push({name: 'authentication'});
		
	}
  },

	computed: {
	  loading() {
		return this.$store.getters.loading;
	  }
	}
};
</script>

<style>

@font-face {
  font-family: 'Gliscor Gothic';
  font-style: normal;
  font-weight: normal;
  src: local('Gliscor Gothic'), url('./assets/fonts/gligoth.woff') format('woff');
}

body, .v-application{
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  color: #FFFFFF !important;
  font-family: 'PT Sans', sans-serif !important;
  font-weight: 400 !important;
}

body .v-application .display-4, body .v-application .display-3, body .v-application .display-2, body .v-application .display-1, body .v-application .headline, body .v-application .title, body .v-application .subtitle-1, body .v-application .subtitle-2, body .v-application .subheading, body .v-application .body-1, body .v-application .body-2, body .v-application h6.title span.initial{
  font-family: 'PT Sans', sans-serif !important;
  line-height: initial !important;

}

h1, h2 , h3, h4, h5, h6, .font-weight-bold{
  font-weight: 700 !important;

}

html body #app .gliscor{
  font-family: 'Gliscor Gothic' !important;
}

.small-icon{
  font-size: 20px !important;
}

.no-boxshadow{
  box-shadow: none !important;
}

.no-radius{ 
  border-radius: 0px !important;
}

.pink-border{
  border: thin solid #e50278 !important;
}

.pink-border-bot, .pink-border-bot.grey.darken-4{
  border-bottom: 1px solid #e50278 !important;
  border-color: #e50278 !important;
}

.v-application .bot-bor-pink{
  border-bottom: 1px solid #e50278 !important;
  border-color: #e50278 !important;
}

.v-application .grey.darken-4.top-bor-pink{
  border-top: 1px solid #e50278 !important;
  border-color: #e50278 !important;
}

.v-application .secondary.pink-top{
  border-top: 1px solid #e50278 !important;
}

.smooth-border:after{
  content:"";
  position: absolute;
  background: #e50278;
  width: 100%;
  height: 1px;
  bottom: -1px;
  display: block;
  transition: color 1000ms
}

.mainmenu_butt{
  border-bottom: 2px solid transparent !important;
  transition: all 500ms !important ;
}

.mainmenu_butt:hover, .mainmenu_butt.highlighted{
  border-bottom: 2px solid #e50278 !important;
  transition: all 500ms !important ;
}

.mainmenu_butt:before, .mainmenu_butt:hover:before{
  background: none !important;
  opacity: 0 !important;
  transition: none !important;
}

.mainmenu_butt .v-ripple__animation.v-ripple__animation--visible{
  width: 105% !important;
}

.h-100{
  height: 100%;
}

.w-100{
  width: 100%;
}

.para-no-pad .v-parallax__content{
  padding: 0px !important;
}

.main-head .v-toolbar__content{
  padding: 0px !important;
}

.gradient{
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+74,000000+100&1+74,0+100 */
  background: -moz-linear-gradient(top, rgba(0,0,0,1) 74%, rgba(0,0,0,0) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(0,0,0,1) 74%,rgba(0,0,0,0) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(0,0,0,1) 74%,rgba(0,0,0,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#00000000',GradientType=0 ); /* IE6-9 */
}

.gradient-bg{
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+0,212121+100 */
  background: #000000; /* Old browsers */
  background: -moz-linear-gradient(top, #000000 0%, #212121 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, #000000 0%,#212121 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, #000000 0%,#212121 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#212121',GradientType=0 ); /* IE6-9 */
}

.logo-bg{
  background: url(./assets/img/shifft_logo.svg);
  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: left;
  background-repeat: no-repeat;
  background-size: contain;
  transition: height 10s;
  transition: all 250ms;
}

.logo-bg-white{
  background: url(./assets/img/shifft_logo_white.svg);
  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: left;
  background-repeat: no-repeat;
  background-size: contain;

}

.logo-bg:hover, .logo-bg-white:hover{
  opacity: 0.8;
  transition: all 250ms;
}


.logo-bg.center-bg, .logo-bg-white.center-bg{
  background-position: center !important;
}

.top-bg .v-image__image.v-image__image--contain{
  background-position: top !important;
}

.center-bg .v-image__image.v-image__image--contain{
  background-position: center !important;
}

.max-container{
  max-width: 1400px !important;
}

.width-100{
  width: 100px !important;
}

.corner-button:before{
  opacity: 1 !important;
  content:"";
  height: 16px;
  width: 16px;
  display: block;
  left: 0px;
  top: 0px;
  position: absolute;
  background: url(./assets/img/Quote_Plane-Pink.svg);
  background-position: right bottom;
  background-repeat: no-repeat;
  transition: all 125ms;
  z-index: 2;
}

.corner-button:hover:before{
  background: url(./assets/img/Quote_Line-Grey.svg);
  left: -15px !important;
  top: -15px !important;
  transition: all 125ms;
}

.corner-button:after{
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  content:"";
  height: 16px;
  width: 16px;
  display: block;
  right: 0px;
  bottom: 0px;
  position: absolute;
  background: url(./assets/img/Quote_Plane-Pink.svg);
  background-position: right bottom;
  background-repeat: no-repeat;
  transition: all 125ms;
  -webkit-transform: rotate(-180deg) !important;
  transform: rotate(-180deg) !important;
}

.corner-button:hover:after{
  background: url(./assets/img/Quote_Line-Grey.svg);
  right: -15px;
  bottom: -15px;
  transition: all 125ms;
  -webkit-transform: rotate(-180deg) !important;
  transform: rotate(-180deg) !important;
}

.corner-button.big-corner:after, .corner-button.big-corner:before{
  height: 32px;
  width: 32px;
}

.corner-button.big-corner:hover:after{
  right: -20px;
  bottom: -20px;
}

.corner-button.big-corner:hover:before{
  left: -20px !important;
  top: -20px !important;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  opacity: 0.5;
  width: 100%;
}

.v-card--reveal.reveal-more{
   opacity: 1;
   background: none !important;
   position: relative;
}

.v-card--reveal.reveal-more:before{
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  display: block;
  background: #e50278;
  z-index: -1;
  opacity: 0.7;
}

.home-card:after{
}

.home-card h3:after{
  background-repeat: no-repeat;
  display: block !important;
  width: 80px !important;
  height: 80px !important;
  content: "" !important;
  position: absolute !important;
  left: 20px !important;
  top: 50% !important;
  margin-top: -40px;
}

.home-card.small-icon h3:after{
  width: 60px !important;
  height: 60px !important;
  top: 50% !important;
  margin-top: -30px !important;
}

.home-card.card-producten h3:after{
  background: url(./assets/img/Icon_Producten.svg) !important;
}

.home-card.card-maatwerk h3:after{
  background: url(./assets/img/Icon_Maatwerk.svg) !important;
}

.home-card.card-cases h3:after{
  background: url(./assets/img/Icon_Cases.svg) !important;
}

.product-item h4:after{
  background-repeat: no-repeat;
  display: block !important;
  width: 100px !important;
  height: 100px !important;
  content: "" !important;
  position: absolute !important;
  left: 50% !important;
  margin-left: -50px;
  top: -110px !important;
}

.product-item.product-energybattle h4:after{
  background: url(./assets/img/Icon_Battle.svg) !important;
}

.product-item.product-p4service h4:after{
  background: url(./assets/img/Icon_P4.svg) !important;
}

.product-item.product-monitoring h4:after{
  background: url(./assets/img/Icon_Monitoring.svg) !important;
}


h3.header-item{
  padding-left: 115px;
}

h3.header-item.item-small{
  padding-left: 90px;
}

h3.header-item:before{
  background-repeat: no-repeat;
  display: block !important;
  width: 100px !important;
  height: 100px !important;
  content: "" !important;
  position: absolute !important;
  left: 0px;
  top: 50%;
  margin-top: -50px;
}

h3.header-item.item-small:before{
  width: 70px !important;
  height: 70px !important;
  margin-top: -35px;
}

 h3.header-item.header-energybattle:before{
  background: url(./assets/img/Icon_Battle.svg) !important;
}


.position-relative{
  position: relative;
}

.position-absolute{
  position: absolute;
}

.blog-counter{
  right: -2px;
  top: -12px;
}

.blog-counter .v-badge__badge{
  padding-right: 6px;
}

.carou-holder{
  width:100% !important;
  height:100% !important;
  -webkit-background-size: cover !important; /* For WebKit*/
  -moz-background-size: cover !important;    /* Mozilla*/
  -o-background-size: cover !important;      /* Opera*/
  background-size: cover !important;         /* Generic*/
  background-repeat: no-repeat !important;
}

.carou-holder.carou-1{
  background: url(https://assets.ghg.nl/app/assets/cache/1724208288/acrhiefpagina-ghg-1280x712.jpg) center center !important;
}

.carou-holder.carou-2{
  background: url(https://fxmedia.s3.eu-west-1.amazonaws.com/featured_images/5bbf1456b614b1539249238.jpeg) center center !important;
}

.carou-holder.carou-3{
  background: url(https://images.idgesg.net/images/article/2019/02/big_data_center_server_racks_storage_binary_analytics_by_monsitj_gettyimages-1005771270_3x2-100787359-large.jpg) center center !important;
}

.carou-holder.carou-4{
  background: url(./assets/img/carou4.jpg);
}

.carou-holder.carou-5{
  background: url(https://www.bergpolder-liskwartier.nl/cache/500x333_85_20180116195318_008387000_1.jpg);
}

.carou-holder.carou-6{
  background: url(https://www.vitrx.co.uk/wp-content/uploads/2017/02/woman-leaning-over-man-pointing-at-computer-screen.jpg);
}

.carou-holder.carou-maps{
  background: url(./assets/img/caroumaps.jpg);
}

.case-bg{
  background: #e5e5e5;
}

.case{
  height: 100px;
  width: 200px;
}

.case.case-1{
  background: url(./assets/img/case1.png)  no-repeat center center !important;
}

.case.case-2{
  background: url(./assets/img/case2.png) no-repeat center center !important;
}

.case.case-3{
  background: url(./assets/img/case3.png) no-repeat center center !important;
}

.case.case-4{
  background: url(./assets/img/case4.png) no-repeat center center !important;
}

.case.case-5{
  background: url(./assets/img/case5.png) no-repeat center center !important;
}

.case.case-6{
  background: url(./assets/img/case6.png) no-repeat center center !important;
}

.case.case-7{
  background: url(./assets/img/case7.png) no-repeat center center !important;
}

.case.case-8{
  background: url(./assets/img/case8.png) no-repeat center center !important;
}

.case.case-9{
  background: url(./assets/img/case9.png) no-repeat center center !important;
}

.case.case-10{
  background: url(./assets/img/case10.png) no-repeat center center !important;
}

.case.case-11{
  background: url(./assets/img/case11.png) no-repeat center center !important;
}

.case.case-12{
  background: url(./assets/img/case12.png) no-repeat center center !important;
}

.partner{
  height: 75px;
  width: 150px;
}

.partner.partner-1{
  background: url(./assets/img/partner1.png)  no-repeat center center !important;
}

.partner.partner-2{
  background: url(./assets/img/partner2.png)  no-repeat center center !important;
}

.partner.partner-3{
  background: url(./assets/img/partner3.png)  no-repeat center center !important;
}

.partner.partner-4{
  background: url(./assets/img/partner4.png)  no-repeat center center !important;
}

.v-parallax__content{
  justify-content: initial !important;
  padding: 0px !important;
}

.head-graph canvas {
  width:101% !important;
  height: auto;
  margin-left: -3px !important;
}

.mobile-bg .v-parallax__image-container img{
  bottom: 15% !important;
}

.mobile-bg2 .v-parallax__image-container img{
  bottom: 30% !important;
}

.v-navigation-drawer .theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before{
  opacity: 0 !important;
}

.z-index-50{
  z-index: 50;
}

.z-index-49{
  z-index: 49;
}

.z-index-0{
  z-index: 0;
}

.pink-triangle::after{
  position: absolute;
  content: '';
  left: 50%;
  margin-left: -20px;
  bottom: -40px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 40px 40px 0 40px;
  border-color: #e50277 transparent transparent transparent;
}

.big-headers table thead tr th{
  font-weight: 700;
  color: initial !important;
  font-size: 14px;
}

.w-50{
  max-width: 50%;
}

.expects-table.v-data-table th{
  height: 45px !important;
}

.expects-table.v-data-table td{
  height: 46px !important;
}

.has-triangle::before, .has-triangle::after{
  position: absolute;
  content: "";
  right: -25px;
  top: 0px;
  transition-delay: 0s !important;
}

.has-triangle.tri-small::before, .has-triangle.tri-small::after{
  right: -20px;
}

.has-triangle.triangle1::before{
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 25px 0 25px 25px;
  border-color: transparent transparent transparent #141414;
  right: -31px;
}

.has-triangle.triangle1.tri-small::before{
  border-width: 20px 0 20px 20px;
}

.has-triangle.triangle1::after{
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 25px 0 25px 25px;
  border-color: transparent transparent transparent #202020;
}

.has-triangle.triangle1.tri-small::after{
  border-width: 20px 0 20px 20px;
}

.v-application a.dashboard-pager{
  color: #58595b;
  text-decoration: none;
  cursor: initial;
}

.v-application a.dashboard-pager.can-press{
  color: white;
  cursor: pointer; 
}

.v-application a.dashboard-pager.can-press:hover{
  text-decoration: underline;
}

.dash-stat{
  padding: 3px;
}

.dash-stat.white-bor{
  border: 1px solid white !important;
}

body .theme--dark.v-sheet.dash-stat.box-nobor{
  border: 0px !important;
  border-color: transparent !important;
}

.percentage-box{
  height:100%;
  min-height: 85px;
  width: 100%;
  background: grey;
  border-radius: 3px;
  font-size: 1.25rem!important;
  font-weight: 500;
}

.percentage-box.half{
  min-height: 35px !important;
  height: 35px !important;
  font-size: 16px !important;
}

.percentage-box.half.auto-stat{
  height: 100% !important;
}

.big-chev{
  font-size:37px !important;
}

.color-neg{
  color: #d5535f !important;
}

.stat-neg{
  background: #d5535f;
}

.stat-neutral{
  background: #212121;
}

.stat-pos1{
  background: #2e5f40;
}

.stat-pos2{
  background: #38885f;
}

.bor-white, .theme--dark.v-card.bor-white {
  border: 1px solid #FFFFFF !important;
  border-color: #FFFFFF !important;;
}


.bot-bor-white{
  border-bottom: 1px solid white;
}

.top-bor-white{
  border-top: 1px solid white;
}

.stat-link{
  text-decoration: none;
  color: white !important;
}

.stat-link span:hover{
  text-decoration: underline;
}

.theme--dark.v-data-table.dark-table.white-borders thead tr th{
  color: white !important;
  border-bottom: 1px solid white;
  vertical-align: top;
}

.no-dec{
  text-decoration: none;
}

.v-data-table.p4-table tr td{
  height: 35px;
  white-space: nowrap!important;
}

.v-data-table.p4-table tr:nth-child(even) {
  background-color: #202020;
}

.small-icon{
  font-size: 14px;
}

.theme--dark.v-data-table.dark-table.mobile-table thead tr th{
  padding-bottom: 20px;
}

.theme--dark.v-data-table.dark-table.mobile-table tr td {
  
  padding-top: 10px;
}

.theme--dark.v-data-table.dark-table.mobile-table tr td:last-child {
  
  height: 69px; 
  padding-bottom: 40px;
}

.theme--dark.v-data-table.dark-table.mobile-table tr td{
  height: 28px;
}

.has-side-border, .has-side-border a{
  height: 35px;
  line-height: 35px;
}

.has-side-border:after{
  content: '';
  width: 5px;
  height: 300%;
  background: black;
  right: -17px;
  top: -10px;
  display: block;
  position: absolute;
}

.status-indicator{
  width: 30px;
  height: 15px;
  display: inline-block;
  border-radius: 3px;
  padding: 1px;
  border: 1px solid white;

}

.status-filler{
  height: 100%;
  width: 100%;
  background: transparent;
  display: block;
}

.status-filler.green{
  background: #28784f;
}

.status-filler.orange{
  background: #28784f;
}

.status-filler.red{
  background: #d14f5b;
}

.no-bg{
  background: none !important;
}

.v-application .grey.darken-4.recolor{
  background: #141414 !important;
}

.v-application .grey.darken-3.recolor{
  background: #202020 !important;
}

body .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){
  color: inherit !important;
}


.p4-table th{
  white-space: nowrap;
}

.split-bg{    
  background: rgb(20,20,20) !important; 
  background: linear-gradient(90deg, rgba(20,20,20,1) 50%, rgba(32,32,32,1) 50%) !important;
}

.cursor-pointer{
  cursor: pointer;
}

</style>
